import { LocalActionKey } from "../../../actions/ActionKeys";
import { LocalAction } from "../../../actions/local";
import { KernelSession } from "../../../types/LocalState";

export const sessions = (
  state: KernelSession[] = [],
  action: LocalAction
): KernelSession[] => {
  switch (action.type) {
    case LocalActionKey.SET_LOCAL_STATE:
      return action.payload.local.sessions;
    default:
      return state;
  }
};
